"use strict";
/* globals module */
/**
 * @module calendarEventStatusRoute
 * @description BaasicCalendarEventStatusRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventStatusRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var CalendarEventStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventStatusRoute, _super);
    function CalendarEventStatusRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-lookups/statuses/{?searchQuery,page,rpp,sort,embed,fields,from,to,ids}';
        _this.getRoute = 'calendar-lookups/statuses/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-lookups/statuses';
        _this.updateRoute = 'calendar-lookups/statuses/{id}';
        _this.deleteRoute = 'calendar-lookups/statuses/{id}';
        _this.purgeRoute = 'calendar-lookups/statuses/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventStatus properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventStatus subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventStatus property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use events starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use events ending to this date.
     * - `ids` - CalendarEventStatus ids which uniquely identify CalendarEventStatus resources that need to be retrieved
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @example calendarEventStatusRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventStatusRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventStatus resource. The route can be expanded using additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventStatus id which uniquely identifies CalendarEventStatus resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @example calendarEventStatusRoute.get(id);
     */
    CalendarEventStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventStatus object that needs to be inserted into the system.
     * @example calendarEventStatusRoute.create(data);
     */
    CalendarEventStatusRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventStatus object used to update specified CalendarEventStatus resource.
     * @example calendarEventStatusRoute.update(data);
     */
    CalendarEventStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventStatus object used to delete specified CalendarEventStatus resource.
     * @example calendarEventStatusRoute.delete(data);
     */
    CalendarEventStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventStatusRoute.purge();
     */
    CalendarEventStatusRoute.prototype.purge = function () {
        return _super.prototype.parse.call(this, this.purgeRoute);
    };
    CalendarEventStatusRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventStatusRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventStatusRoute);
    return CalendarEventStatusRoute;
}(common_1.BaseRoute));
exports.CalendarEventStatusRoute = CalendarEventStatusRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
